export default __webpack_public_path__ + "static/media/hauwa.a4f8c1f8.jpg";